import { Typography } from '@mui/material'
import React from 'react'

export function Titulo({titulo, size}) {
    return (
        <Typography
            variant="h1"
            color="primary"
            sx={{
                marginY: "1em",
                fontSize: size,
                textAlign: "center"
            }}
        >
            {titulo}
        </Typography>
    )
}

